import { useEffect, useState } from 'react'
import { Button, HStack, Text, VStack } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { createFeedback, updateFeedback } from 'API/feedback'
import SvgIcon from 'components/SvgIcon'
import { EQualityOfSearchFeature } from 'constants/user'
import FeedbackDetail from '../FeedbackDetail'

const UserFeedback = () => {
  const { authStore, searchStore } = useStores()
  const { userDetail } = authStore
  const { searchKeyword } = searchStore
  const [feedbackId, setFeedbackId] = useState<number>()
  const [showFeedbackDetail, setShowFeedbackDetail] = useState<boolean>(false)
  const [isOpenFeedbackModal, setIsOpenFeedbackModal] = useState<boolean>(false)

  async function handleVoteFeedback(value: EQualityOfSearchFeature): Promise<void> {
    setShowFeedbackDetail(true)
    const feedback = await createFeedback({
      searchKeyword,
      userId: userDetail?.id,
      qualityOfSearchFeature: value
    })
    setFeedbackId(feedback?.id)
  }

  async function handleSubmitFeedback(text: string): Promise<void> {
    if (feedbackId) {
      await updateFeedback(feedbackId, { text })
      setFeedbackId(undefined)
      setShowFeedbackDetail(false)
    }
  }

  useEffect(() => {
    setFeedbackId(undefined)
    setShowFeedbackDetail(false)
  }, [searchKeyword])

  return (
    <HStack
      width="full"
      height="80px"
      justify="space-between"
      background="gray.200"
      borderRadius={6}
      borderLeft="4px solid #718096"
      padding={4}
      _hover={{ cursor: showFeedbackDetail && 'pointer' }}
      onClick={() => showFeedbackDetail && setIsOpenFeedbackModal(true)}
    >
      {showFeedbackDetail ? (
        <HStack fontSize="16px" fontWeight={700} lineHeight={6} spacing={0}>
          <HStack spacing={1}>
            <SvgIcon size={16} iconName="circle-check" color="gray.700" />
            <Text color="gray.700">Thank you for your feedback.</Text>
          </HStack>
          <Text color="primary.500" cursor="pointer" textDecoration="underline">
            Tell us why
          </Text>
        </HStack>
      ) : (
        <>
          <VStack width="full" align="flex-start" fontSize={{ base: 'sm', md: 'md' }} spacing={0}>
            <Text color="gray.700" fontWeight={700} lineHeight={6}>
              How’s your search going?
            </Text>
          </VStack>
          <HStack spacing={4}>
            <Button
              width={{ base: '48px', lg: '300px' }}
              height="48px"
              variant="solid"
              padding={0}
              fontSize={{ base: '0', lg: '16px' }}
              fontWeight={600}
              background="gray.200"
              gap={{ base: 0, lg: 2 }}
              border="2px solid #F7FAFC"
              _hover={{ background: 'gray.50' }}
              _active={{ background: 'gray.50' }}
              onClick={() => handleVoteFeedback(EQualityOfSearchFeature.GOOD)}
            >
              <SvgIcon size={20} iconName="thumb-up" />
              Helpful
            </Button>
            <Button
              width={{ base: '48px', lg: '300px' }}
              height="48px"
              variant="solid"
              padding={0}
              fontSize={{ base: '0', lg: '16px' }}
              fontWeight={600}
              background="gray.200"
              gap={{ base: 0, lg: 2 }}
              border="2px solid #F7FAFC"
              _hover={{ background: 'white' }}
              onClick={() => handleVoteFeedback(EQualityOfSearchFeature.BAD)}
            >
              <SvgIcon size={20} iconName="thumb-down" />I can not find what I need
            </Button>
          </HStack>
        </>
      )}
      <FeedbackDetail
        isOpen={isOpenFeedbackModal}
        onClose={() => setIsOpenFeedbackModal(false)}
        handleSubmitFeedback={handleSubmitFeedback}
      />
    </HStack>
  )
}

export default observer(UserFeedback)
